// 上传模块
import { uploadStatus } from '@/constants/commonStatus.js'
import { uploadImage } from '@/api/home'
const Upload = {
  namespaced: true,
  state: {
    loadingStatus: 0,
    uploadingList: [],
    uploadedList: [],
    end: false
  },
  mutations: {
    SET_UPLOADING_LIST: (state, uploadingList) => {
      state.uploadingList = uploadingList
    },
    SET_UPLOADED_LIST: (state, uploadedList) => {
      state.uploadedList = uploadedList
    },
    SET_UPLOADED_STATUS: (state, loadingStatus) => {
      state.loadingStatus = loadingStatus
    },
    RESET_DATA: state => {
      state.loadingStatus = uploadStatus.init
      state.uploadingList = []
      state.uploadedList = []
    }
  },
  getters: {
    isUploading(state) {
      return state.loadingStatus === uploadStatus.startLoading
    }
  },
  actions: {
    FileUpload({ commit, getters }, file) {
      commit('RESET_DATA')
      const img = new Image()
      this.uploadSrc = img.src = URL.createObjectURL(file)
      commit('SET_UPLOADING_LIST', [this.uploadSrc])
      commit('SET_UPLOADED_STATUS', uploadStatus.startLoading)
      const originSize = file.size
      const maxSize = 512 * 1024
      let quality = 0.7
      if (maxSize / originSize < 0.7) {
        quality = maxSize / originSize
      }
      let fileType = file.type
      if (fileType === 'image/png') {
        fileType = 'image/jpeg'
      }
      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        const width = img.width
        const height = img.height

        canvas.width = width
        canvas.height = height
        ctx.drawImage(img, 0, 0, width, height)
        canvas.toBlob(
          compressedBlob => {
            uploadImage(compressedBlob)
              .then(res => {
                console.log(compressedBlob, 'compressedBlob')
                if (res.status === 0 && res.result.image_url) {
                  if (!getters.isUploading) {
                    // 已删除图片
                    return
                  }
                  commit('SET_UPLOADED_LIST', [res.result.image_url])
                  commit('SET_UPLOADED_STATUS', uploadStatus.success)
                }
              })
              .catch(() => {
                commit('SET_UPLOADED_STATUS', uploadStatus.fail)
              })
          },
          fileType,
          quality
        )
      }
      img.onerror = () => {
        console.log('上传失败')
      }
    }
  }
}

export default Upload
